export default __webpack_public_path__ + "static/media/Artboard 26.677118cf.png";